// frontend/src/utils/preferences.js
// Utility functions for accessing preferences from localStorage
// This provides a centralized way to access preferences with fallbacks


export const getUserPreferences = () => {
  try {
    const stored = localStorage.getItem('userPreferences');
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Error parsing user preferences from localStorage', error);
  }
  return {};
};

export const getPreference = (key, defaultValue = null) => {
  const preferences = getUserPreferences();
  return preferences[key] ?? defaultValue;
};

export const getGlobalThreshold = () => {
  try {
    const userPrefs = localStorage.getItem('userPreferences');
    if (userPrefs) {
      const prefs = JSON.parse(userPrefs);
      return parseInt(prefs.global_filter_threshold, 10) || 10;
    }
  } catch (error) {
    console.warn('Error parsing userPreferences for global threshold:', error);
  }  
  // Default fallback
  return 10;
};

export const getDistanceUnit = () => {
  return getPreference('distance_unit', 'km');
};

export const getLanguage = () => {
  return getPreference('language', 'en');
};

export const getTheme = () => {
  return getPreference('theme', 'light');
};

export const getDateFormat = () => {
  return getPreference('date_format', 'MM/DD/YYYY');
};

export const getTimeFormat = () => {
  return getPreference('time_format', '12h');
};